import React from 'react';
import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Memo, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Area, EAA_Select, EAA_Upload, EAA_Add_Btn } from '~/components/EditAndAddItem';

const titleWidth = 120;
const errorLeft = 20 + titleWidth;

const emptyBody2 = {
  a: '',
  b: [],
};

const emptyBody = {
  a: '',
  sub1_sub1: [],
};

const App2 = ({ data = [], disabled = false, changeData = () => {} }) => {
  const ary = JSON.parse(JSON.stringify(data));
  if (ary.length === 0)ary.push({ ...emptyBody2 });

  const saveSub = dataAry => {
    changeData(dataAry);
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };
  return (
    <SearchBar text='佐證資料' style={{ marginTop: 8 }} defaultOpen>
      {ary.map((o, i) => (
        <EAA_Area
          key={i}
          color='#186279'
          backgroundColor='white'
          title='佐證資料'
          titleItem={(
            <EAA_Add_Btn
              style={{ marginLeft: 12 }}
              disabled={disabled}
              del={i > 0}
              onClick={(i > 0) ? () => delRow(i) : () => addRow()}
            />
          )}
        >
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} bol text='佐證對應內容' subtitle='說明' subtitleColor='black' />
                <EAA_Memo disabled={disabled} displayBorder hint='詳答' value={o.a} onChange={data => { ary[i].a = data; saveSub(ary); }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />} */}
              <div style={{ marginLeft: errorLeft, color: '#ff0000', fontWeight: 500, fontSize: 16 }}>註: 內容眾多請條列說明，提供項目目錄</div>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} bol text='上傳檔案' />
                <EAA_Upload disabled={disabled} displayBorder value={o.b} onChange={data => { ary[i].b = data; saveSub(ary); }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />} */}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>
        </EAA_Area>
      ))}
    </SearchBar>
  );
};

const App = ({ data = [], disabled = false, changeData = () => {} }) => {
  const ary = JSON.parse(JSON.stringify(data));
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData(dataAry);
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  return (
    <SearchBar text='針對上開事項補充說明' style={{ marginTop: 8 }}>

      {ary.map((o, i) => (
        <EAA_Area
          key={i}
          backgroundColor='white'
          title='針對上開事項補充說明'
          titleItem={(
            <EAA_Add_Btn
              style={{ marginLeft: 12 }}
              disabled={disabled}
              del={i > 0}
              onClick={(i > 0) ? () => delRow(i) : () => addRow()}
            />
          )}
        >
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} bol text='補充事項說明' />
                <EAA_Memo disabled={disabled} displayBorder hint='詳答' value={o.a} onChange={data => { ary[i].a = data; saveSub(ary); }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />} */}
            </EAA_Item>
          </EAA_Row>
          <App2 data={o.sub1_sub1} disabled={disabled} changeData={data => { ary[i].sub1_sub1 = data; saveSub(ary); }} />
        </EAA_Area>
      ))}

    </SearchBar>
  );
};

export default App;
